/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.com>
 */
import 'APP_THEME/_common/legacy/core.mobile';

import 'resources/less/themes/base/pages/standalone/about_us.less';
import 'blueimp-file-upload/css/jquery.fileupload.css';

import 'resources/less/themes/base/pages/standalone/contact_us.less';

import contactUsPage from 'assets/js/modules/pages/contactUsPage';

$(function() {
    contactUsPage.init($('#popup-contact-us-orders').data('show-popup'));
});
